const KEY_SEPARATOR = ':';

export function jiraFieldsCacheKey(
  projectId: string,
  issueTypeId: string
): string {
  return `${projectId}${KEY_SEPARATOR}${issueTypeId}`;
}

export function jiraProjectQueryCacheKey(
  projectId: string,
  query: string
): string {
  return `${projectId}${KEY_SEPARATOR}${query}`;
}

export function jiraFieldOptionsCacheKey(
  projectId: string,
  issueTypeId: string,
  fieldId: string
): string {
  return `${projectId}${KEY_SEPARATOR}${issueTypeId}${KEY_SEPARATOR}${fieldId}`;
}
